import { useTranslate } from '@i18n';
import { Box, Text } from '@ui';

export const VideoEmpty = () => {
    const t = useTranslate();
    return (
        <Box width="100%" height="100%" display="flex" alignItems="center" justifyContent="center">
            <Text>{t('error_message.no_video_available')}</Text>
        </Box>
    );
};
